// What a Stripe subscription record means right now (#4619).
//
// The twin of payment_manager_v2/entitlements.py's subscription_cancel_date
// and subscription_has_ended; the two are pinned to the same cases by
// src/__tests__/subscriptionState.test.js and test_subscription_ended.py. The rule: an
// ended subscription is ended even if the webhook that says so never came.

// When a scheduled cancellation takes effect: Stripe's current period end,
// which the webhooks keep in sync. subscription_end_date is only our own
// estimate (grant time + the plan's term) and is the fallback. Reading the
// estimate first showed a live subscriber "Cancels on July 14, 2026" in
// October while Stripe said October 19.
// Whether the plan held is Through Graduation (#4986's pass_product_id):
// there is no upgrade from it (#5228).
export function holdsThroughGraduation(purchases) {
    return (purchases || {}).pass_product_id === 'through_graduation';
}

export function subscriptionCancelDate(purchases) {
    const p = purchases || {};
    return p.subscription_current_period_end || p.subscription_end_date || null;
}

function parseDate(value) {
    if (!value) return null;
    const d = new Date(value);
    return Number.isNaN(d.getTime()) ? null : d;
}

// True when the record still says active but the cancellation it scheduled
// has passed, or the server already said so. A renewing subscription past
// its period end is not judged here (the server asks Stripe), and an
// unreadable date is not evidence of an end.
export function subscriptionHasEnded(purchases, now = new Date()) {
    const p = purchases || {};
    if (p.subscription_ended) return true;
    if (!p.subscription_active || !p.subscription_cancel_at_period_end) return false;
    const end = parseDate(subscriptionCancelDate(p));
    return end !== null && end.getTime() <= now.getTime();
}

// A pass bought as ONE payment for its term (the rupee Season Pass, #4966,
// ADR 0060): no Stripe subscription, nothing renews and nothing to cancel.
// Its record is written as a plan whose end is already scheduled, so the
// two functions above read it as ended on time; this says which kind it is,
// so the plan panel says "Runs through" instead of offering Cancel or
// Reactivate. The twin of entitlements.ONE_TIME_TERM, pinned equal by
// test_checkout_flows.py.
export const ONE_TIME_TERM = 'one_time';

export function isOneTimePass(purchases) {
    return (purchases || {}).subscription_term === ONE_TIME_TERM;
}
